import React, {Component} from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';
import capitalize from 'lodash/capitalize';
import {Button, ButtonGroup} from 'react-bootstrap';
import ReactTooltip from 'react-tooltip';
import Mousetrap from 'mousetrap';

const erase = -100;
const decrease = -50;
const increase = 50;

export default class EraseBoostPicker extends Component {
    static propTypes = {
        eraseBoostLevel: PropTypes.number,
        onChange: PropTypes.func,
    };

    componentDidMount() {
        const {onChange} = this.props;
        Mousetrap.bind('e', (e) => {
            e.preventDefault();
            onChange(erase);
        });

        Mousetrap.bind('d', (e) => {
            e.preventDefault();
            onChange(decrease);
        });

        Mousetrap.bind('i', (e) => {
            e.preventDefault();
            onChange(increase);
        });
    }


    componentWillUnmount() {
        // noinspection JSUnresolvedFunction
        Mousetrap.unbind(['e', 'd', 'i']);
    }
    render() {
        const {eraseBoostLevel, onChange} = this.props;
        return (
            <div className="erase-boost-picker">
                <ButtonGroup vertical>
                    {
                        map({erase, decrease, increase}, (n, label) => (
                            <Button
                                key={`eb${n}`}
                                active={eraseBoostLevel === n}
                                data-tip
                                data-for={`${label}ToolTip`}
                                onClick={() => onChange(n)}
                            >
                                {capitalize(label)}
                            </Button>
                        ))
                    }
                </ButtonGroup>
                <ReactTooltip id="eraseTooltip" place="bottom" delayShow={400} className="light-tool-tip" type="light">
                    <div>{'Fully erase effect'}</div>
                    <kbd>{'e'}</kbd>
                </ReactTooltip>
                <ReactTooltip id="reduceTooltip" place="bottom" delayShow={400} className="light-tool-tip" type="light">
                    <div>{'Decrease effect by half'}</div>
                    <kbd>{'d'}</kbd>
                </ReactTooltip>
                <ReactTooltip id="boostTooltip" place="bottom" delayShow={400} className="light-tool-tip" type="light">
                    <div>{'Increase effect by half'}</div>
                    <kbd>{'i'}</kbd>
                </ReactTooltip>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/EraseBoostPicker.js